module.exports = __webpack_public_path__ + "static/img/1.7cd642a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taidi/1.png
// module id = xA9u
// module chunks = 19